// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ThreeLineOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_4199)"},"children":[{"tag":"path","attrs":{"d":"M4 18V2h2v16H4zm8-12v16h2V6h8zm6 12V2h2v16h-2z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_4199"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"three-line","theme":"outlined"};

const ThreeLineOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ThreeLineOutlinedSvg} />;
  ThreeLineOutlined.displayName = 'ThreeLineOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ThreeLineOutlined);
